import InstructionRepository from './instruction.repository'

export default {
  instruction: InstructionRepository,
}
